module.exports = __webpack_public_path__ + "img/Z61_11.8c6a38c1.jpg";